import React from "react";
import { Link } from "react-router-dom";

export const StatusColumnFormatter = (cellContent, row) => {
  let colotCode;
  switch (row.StatusCode) {
    case "DF":
      colotCode = "#C0C0C0";
      break;
    case "OP":
      colotCode = "#4caf50";
      break;
    case "BK":
      colotCode = "#8950FC";
      break;
    case "OFP":
      colotCode = "#32C5D2";
      break;
    case "AT":
      colotCode = "#ff7c43";
      break;
    case "IT":
      colotCode = "#6993ff";
      break;
    case "AR":
      colotCode = "#FFA800";
      break;
    case "DL":
      colotCode = "#009688";
      break;
    case "CL":
      colotCode = "#991f17";
      break;

    default:
      colotCode = "";
      break;
  }

  return (
    <Link
      className={`label label-lg text-white label-inline font-weight-bold py-4`}
      style={{ backgroundColor: colotCode, whiteSpace: "nowrap" }}
      to={`/trackload/${row.Id}/details`}
    >
      {row.Status}
    </Link>
  );
};
